var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _g, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTest3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 779.23 900.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M430.68 387.77c-3-4.38-6.01-8.76-9.01-13.14 9.17-10.45 17.49-16.09 24.66-15.36 6.15.63 12.4 2.57 15.75 16.93-10.19 5.89-20.72 9.26-31.4 11.57zm-95.97.05c3-4.38 6.01-8.76 9.01-13.14-9.17-10.45-17.49-16.09-24.66-15.36-6.15.63-12.4 2.57-15.75 16.93 10.19 5.89 20.72 9.26 31.4 11.57z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M243.41 369.22l33.95-50.26c1.56 14.86 10.46 24.64 21.63 31.93l4.03 25.26c10.29 5.63 19.81 9.34 31.69 11.67l13.55-20.15c11.32 1.88 22.76 2.84 34.34 2.8v-.11c11.57.04 23.01-.91 34.34-2.8l13.74 20.2c11.88-2.33 21.2-5.99 31.49-11.62l4.03-25.37c11.17-7.29 20.08-17.06 21.63-31.93l33.95 50.26c1.91 2.83 7.12 9.83 9.82 17.8 2.66 7.83 2.83 16.62 2.83 20l-.16 79.31c-.02 10.85.05 14.41-4.91 24.41l-42.11 84.74c-7.43 15.06-21.37 25.58-40.98 32.16-17.05 5.72-38.59 10.17-63.67 10.13v.11c-25.08.04-46.62-4.41-63.67-10.13-19.62-6.58-33.55-17.1-40.98-32.16l-42.1-84.74c-4.97-10-4.89-13.56-4.92-24.41l-.16-79.31c0-3.38.17-12.18 2.83-20 2.71-7.97 7.91-14.97 9.82-17.8zm251.1 75.73c-21.49-4.9-46.23 17.18-55.25 49.31-9.02 32.13 1.09 62.15 22.59 67.04 21.49 4.9 46.23-17.18 55.25-49.31 9.02-32.13-1.09-62.15-22.59-67.04zm-223.83 0c-21.49 4.9-31.61 34.91-22.59 67.04 9.02 32.13 33.75 54.21 55.25 49.31 21.49-4.9 31.61-34.91 22.59-67.04-9.02-32.13-33.75-54.21-55.25-49.31z",
    fill: "#e30038",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M475.55 393.12c-6.65 3.43-13.79 6.14-21.16 8.5l15.29 30.01 12.97 12.61 18.65 1.93c1.66-.68 1.86-.76 3.52-1.45 5.38-3.37 10.26-6.97 14.43-10.88v42.14c1.39 9.39 1.59 18.98 0 28.88v18.95l8.25-9.44V424.2c7.57-11.52 9.22-25.66 1.18-44.07-19.93 10.15-30.18 23.01-30.94 38.51l7.08 26.08c-11.3-27.57-22.59-55.13-33.89-82.7 1.54 10.37 3.08 20.73 4.61 31.09-10.53 4.94-21.8 8.57-33.45 11.54 1.12-.23 2.24-.47 3.35-.7 5.43 10.87 10.87 21.74 16.3 32.62-3.55 4.96-6.39 10.86-8.32 17.95-15.74-28.48-31.48-56.97-47.22-85.45l10.72-1.5c8.39 12.36 16.77 24.73 25.16 37.09-3.81-5.63-7.61-11.26-11.42-16.89 9.2-3.14 18.41-6.28 27.61-9.41 1.38-.62 2.77-1.24 4.15-1.87 4.37 5.54 8.74 11.09 13.11 16.63zm-185.9 0l.62-2.82 8.18-36.95 4.32 23.12 14.52 5.92-3.79 19.27-23.86-8.53zm23.79 198.38c-1.97-.03-3.98-.27-6.16-1.35-1.61 2.29-3.23 4.58-4.84 6.86 6.1 3.35 10.02 2.05 11-5.51zm53.21 5.53c-9.01-3.87-16.52-8.39-22.69-15.16 4.88 11.6 13.99 24.99 24.45 29.96 15.32 7.27 20.43-2.82 8.8-11.19-6.44-4.63-9.64-7.84-14.81-13.12 1.12 3.86 1.87 5.94 4.25 9.5zm-63.78-141.42c-2.96-2.86-6.44-5.35-10.62-7.36l12.4-10.21c2.03 3.09 3.78 6.36 4.9 10.04-2.23 2.51-4.45 5.02-6.68 7.53zm168.68 159.21c-10.34 7.48-22.58 12.92-36.26 16.79l16.66-37.96c.37-2.51 3.04-2.33 5-3.02l4.98 6.67c1.64 2.2 3.61-.98 6.08-3.93 4.86-5.8 6.2-13.68 3-17.59-2.53-3.1-7.15-2.78-11.38.36l6.25-14.25c10.73 1.03 21.01-3.13 30.68-14.3l-25 67.23zm-30.81-56.59h.02l-10.55 2v-90.19l21.84-4.29c-4.81 7.63-8.58 15.61-11.28 23.95-4.96 15.37-6.97 33.54-1.44 49.02 2.6 7.27 6.64 13.01 11.9 17.48l.69-.13 3.72 3.57-31.99 74.64c-5.81.95-11.63 1.9-17.45 2.86 4.45-12.45 8.89-24.9 13.34-37.35 8.09-12.31 15.09-26.24 21.18-41.55zm-30.21-85.68l11.58-1.54-.33 90.41-11.24 1.13v-90zm-62.75-20.68c-6.59 1.67-9.33 3.17-15.29 6.03 7.93-23.2 18.92-40.22 34.67-47.99-9.83 9.09-17.33 23.99-19.38 41.96zm14.84-3.22c-.58-12.53.44-24.72 4.22-33.91-8.06 10.39-11.39 21.81-12.57 35.4 2.7-.82 6.3-1.05 8.35-1.49zm107.07-17.04c3.12-.53 5.95-.6 8.69-.17l-8.69.17zm8.7-.17c4.41.69 8.56 2.69 13.24 6.2l-13.24-6.2zm13.24 6.2zm0 0c2.96 2.22 6.12 5.04 9.69 8.51l-9.69-8.51z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M322.23 467.49c19.66 4.89 39.71 5.97 59.27 6.15 20.44.18 42.9-1.72 61.65-6.15-11.64-16.37-40.39-20.01-60.53-20.21-19.85-.19-49.28 4.68-60.39 20.21z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M325.53 559.23c2.69 6.57 5.39 13.15 8.08 19.72 27.69-8.96 46.62-6.5 59.89 3.61 4.5 3.43 4.92 6.94 3.26 12.15-3.63 11.41-8.87 21.39-17.73 22.73 13.09.95 22.31-6.32 29.39-16.63a86.66 86.66 0 013.77 7.99c11.15-13.47 20.96-29.1 27.58-49.83-33.52 6.37-66.16 6.69-98.18 2.66l7.35.7v-91.19l-8.98-1.13v91.42c-4.83-.63-9.64-1.36-14.43-2.18zm-72.54-119.27v18.11c-10.74 17.53-10.86 39.48 0 66v5.78l-13.09-12.77 39.07 81.08c8.13 14.68 31.51 30.4 48.46 32.73-6.67-10.73-13.33-21.46-19.99-32.18-11.58-2.75-15.72-10.65-14.03-22.59-3.7-5.96-7.4-11.92-11.11-17.88-11.73-6.63-20.93-16.91-29.31-28.4l-15.18-15.74v-90.21c-.85-1.42-.08-.66-.82-2.32 10.19-3.38 16.46-20.96 16.21-30.23 2.82 3.05 7.35 8.79 9.16 11.25 7.44-27.86 7.4-51.56-2.21-50.95 8.23-5.4 12.78-1.02 14.62 10.59 3.8-7.48 7.61-14.97 11.41-22.46l12.83 11.09c-3.12 14.08-6.23 28.15-9.35 42.23 5.92 3.16 13.7 6.04 20.53 8.26l-15.11 30.15-19.78 12.78c-1.77 1.14-8.9 1.96-10.77 2.92-1.38-.84-2.76-1.67-4.13-2.51-2.69-1.65-5.15-3.21-7.39-4.76zm21.77-77.71l.05 5.19c.01-1.74 0-3.47-.05-5.19zm192.75 211.48c-.54 4-1.38 7.62-3.15 10.08 1.8 2.38 3.61 4.75 5.41 7.12 3.93-8.27 4.37-14.65-2.26-17.21zm61.16-193.6c-5.23 2.84-10.13 5.94-14.66 9.32-4.11-20.05-11.61-34.31-22.88-31.34 3.11-13.57 12.32-11.44 27.78 6.75 3.25 5.09 6.51 10.18 9.76 15.27zM312.7 465.66l1.45.29-5.08-19.72 24.01-56.25 15.18-22.31 6.84 1.75-40.91 96.54 20.21 4.01v90.41c-6.82-1.38-13.64-2.76-20.47-4.14 10.6-10.71 15.24-25.31 15.24-39.68 0-15.73-5.82-32.77-16.47-50.89zm149.73-89.18l13.11 16.63-21.41-12.9 8.3-3.73zM299.82 561.85c3.76 0 7.43-1.26 11.04-3.54 15.16 25.93 30.33 51.87 45.5 77.8-4.19-.63-8.38-1.26-12.57-1.9-14.65-24.12-29.31-48.25-43.96-72.37zm94.33-113.89c3.18.28 6.36.57 9.55.85-5.97-21.06-14.03-36.59-26.25-41.14 11.34 10.04 14.58 25.81 16.71 40.29zm56.86 18.05c1.28-9.41 3.86-18.6 9.08-27.36l8.21 12.32c-6.03 4.61-11.76 9.67-17.29 15.04zm-8.36.52c-14.42-46.24-32.8-63.74-48.08-70.87-20.92-9.75-42.84 6.9-59.64 39.46 33.44-50.87 61.22-35.87 74.66 14.78 17.12 2.68 23.68 7.67 33.06 16.63z",
    fill: "#7e0530",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M270.68 444.95c21.49-4.9 46.23 17.18 55.25 49.31 9.02 32.13-1.09 62.14-22.59 67.04-21.49 4.9-46.23-17.18-55.25-49.31-9.02-32.13 1.09-62.15 22.59-67.04zm223.83 0c-21.49-4.9-46.23 17.18-55.25 49.31-9.02 32.13 1.09 62.15 22.59 67.04 21.49 4.9 46.23-17.18 55.25-49.31 9.02-32.13-1.09-62.15-22.59-67.04z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M308.74 461.58c7.44 8.56 13.57 19.81 17.19 32.68 1.1 3.91 1.91 7.78 2.45 11.58l-41.19 54.43c-12.28-4.11-24.11-15.35-32.18-30.78l53.73-67.92z",
    fill: "#45454d",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M494.51 444.95L461.85 561.3c-4.43-1.01-8.37-3.09-11.76-6.03l29.45-109.67c5.01-1.49 10.08-1.78 14.98-.66zm24.78 31.3c-2.4-13.13-8.65-23.58-17.84-28.65l-30.67 114.24c10.3-1 20.74-7.4 29.39-17.46l19.12-68.13z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M277.95 595.59c11.04 31.88 70.97 42.85 106.74 42.85 33.91 0 94.25-13.41 102.29-42.85v27.15c-7.04 34.01-70.57 46.61-106.22 45.97-34.04-.61-92.31-10.42-102.81-45.97v-27.15z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M451.56 511.47c14.78 4.4 28.8-18.91 15.41-36.44 6.65-6.18 13.69-8.46 21.04-7.67 12.38 11.98 8.63 33.63 4.52 44.27-4.88 12.62-16.82 26.33-34.59 23.25-5.6-7.18-7.01-13.12-6.38-23.41zm-137.71 0c-14.78 4.4-28.8-18.91-15.41-36.44-6.65-6.18-13.69-8.46-21.04-7.67-12.39 11.98-8.63 33.63-4.52 44.27 4.88 12.62 16.82 26.33 34.59 23.25 5.6-7.18 7.01-13.12 6.38-23.41z",
    fill: "#d30334",
    fillRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M382.6 339.89c57.64 0 104.65-21.96 104.65-48.89s-47.01-48.89-104.65-48.89S277.95 264.07 277.95 291s47.01 48.89 104.65 48.89z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M342.52 253.42c.64 19.03-16.73 31.31-21.91 44.33-6.99-2.13-14-4.21-20.98-6.4-26.87-8.45 16.29-36.29 42.88-37.94z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M383.58 256.89c-24.1.75-34.63 8.8-35.53 13.45-1.74 8.97 27.76 13.6 34.69 13.52 7.07-.09 36.37-3.62 35.88-12.65-.4-7.29-19.73-14.33-35.04-14.32z",
    fill: "#d30334",
    fillRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#7e0530",
    fillRule: "evenodd",
    d: "M269.45 469.1l-9.29 20.48 32.21-2.46 3.7-16.15-15.4-4.39-11.22 2.52z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M285.4 540.34l19.98-.43 6.74-14.6 2.21-13.52-9.1-4.2-19.83 32.75zm-15.79-13.94l31.95-28.02 3.04 6.18-24.25 32.59-10.75-10.75z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M308.44 533.29c-8.7 9.28-22.07 10.23-31.75 1.3-10.65-9.82-20.79-30.05-16.13-47.56 1.55-5.82 5.22-11.63 11.92-18.61l.91 4.53c-7.49 13.88-4.99 29.92.08 40.3 7.37 15.07 15.86 25.15 34.97 20.04z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M267.83 471.83c2.1-1.38 2.57-1.88 3.32-2.66l4.71-1.51-2.47 5.28c-2.79 5.16-4.19 10.62-4.59 15.97l-4.38.34-5.15.39c.88-7.36 4.44-13.69 8.56-17.82z",
    fill: "#45454d",
    fillRule: "evenodd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M312.6 524.96c-1.67 1.3-3.56 2.23-5.66 2.71-11.47 2.61-24.66-9.16-29.47-26.3-4.15-14.8-.7-28.75 7.7-33.97",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M313.77 514.2c-.98.63-2.05 1.09-3.21 1.35-8.13 1.85-17.49-6.5-20.91-18.66-3-10.7-.4-20.77 5.81-24.31 7.06 5.63 13.1 14.84 16.21 25.93 1.52 5.41 2.19 10.73 2.1 15.69z",
    fill: "#000003",
    fillRule: "evenodd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M298.98 496.83l-19.86 9.45M291.96 490.44l-16.03 2.94M292.53 482.9l-16.23-.68M294.47 476.87l-13.82-3.82"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M312.62 506.19c-.64.41-1.34.71-2.1.88-5.32 1.21-11.43-4.25-13.67-12.2-1.96-6.99-.26-13.58 3.8-15.88 4.61 3.68 8.56 9.7 10.6 16.95.99 3.54 1.43 7.01 1.37 10.25z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M308.44 533.29c-3.21 3.43-7.07 5.72-11.14 6.8l-9.92.22c-.56-.12-1.13-.27-1.69-.44l4.29-7.09c4.86 2.17 10.8 2.56 18.45.52zm-38.67-6.73l-.13-.18 7.39-6.48c2.5 4.17 5.25 7.68 8.56 10.23l-5.23 7.03-10.59-10.6z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M286.04 518.11l13.56-12.9M294.94 525.65l9.9-15.1M304.32 528.02l5.44-15.69M307.7 533.34c-1.25.68-2.6 1.19-4.03 1.51-12.88 2.94-27.71-10.3-33.12-29.56-4.61-16.42-.88-31.91 8.29-37.95"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M276.38 467.01c13.73-3.13 29.53 10.97 35.29 31.49 5.76 20.52-.7 39.69-14.43 42.82-13.73 3.13-29.53-10.97-35.29-31.49-5.76-20.52.7-39.69 14.43-42.82z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#7e0530",
    fillRule: "evenodd",
    d: "M495.75 469.1l9.28 20.48-32.21-2.46-3.69-16.15 15.39-4.39 11.23 2.52z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M479.8 540.34l-19.98-.43-6.74-14.6-2.21-13.52 9.1-4.2 19.83 32.75zm15.79-13.94l-31.95-28.02-3.04 6.18 24.25 32.59 10.75-10.75z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M456.76 533.29c8.7 9.28 22.07 10.23 31.75 1.3 10.65-9.82 20.79-30.05 16.13-47.56-1.55-5.82-5.22-11.63-11.92-18.61l-.91 4.53c7.49 13.88 5 29.92-.08 40.3-7.37 15.07-15.86 25.15-34.97 20.04z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M497.37 471.83c-2.1-1.38-2.44-1.79-3.19-2.58l-4.77-.89 2.4 4.59c2.79 5.16 4.19 10.62 4.59 15.97l4.38.34 5.15.39c-.88-7.36-4.44-13.69-8.56-17.82z",
    fill: "#45454d",
    fillRule: "evenodd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M452.6 524.96c1.67 1.3 3.56 2.23 5.67 2.71 11.47 2.61 24.66-9.16 29.47-26.3 4.15-14.8.7-28.75-7.7-33.97",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M451.43 514.2c.98.63 2.05 1.09 3.21 1.35 8.13 1.85 17.49-6.5 20.91-18.66 3-10.7.4-20.77-5.81-24.31-7.06 5.63-13.1 14.84-16.21 25.93-1.52 5.41-2.19 10.73-2.1 15.69z",
    fill: "#000003",
    fillRule: "evenodd"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M466.22 496.83l19.86 9.45M473.24 490.44l16.03 2.94M472.66 482.9l16.23-.68M470.72 476.87l13.83-3.82"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M452.58 506.19c.64.41 1.34.71 2.1.88 5.32 1.21 11.43-4.25 13.67-12.2 1.96-6.99.26-13.58-3.8-15.88-4.61 3.68-8.56 9.7-10.6 16.95-.99 3.54-1.43 7.01-1.37 10.25z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M456.76 533.29c3.21 3.43 7.07 5.72 11.14 6.8l9.92.22c.56-.12 1.13-.27 1.69-.44l-4.29-7.09c-4.86 2.17-10.8 2.56-18.46.52zm38.67-6.73l.13-.18-7.39-6.48c-2.5 4.17-5.25 7.68-8.55 10.23l5.23 7.03 10.59-10.6z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M479.15 518.11l-13.56-12.9M470.26 525.65l-9.91-15.1M460.88 528.02l-5.45-15.69"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M488.81 467.01c-13.73-3.13-29.53 10.97-35.29 31.49-5.76 20.52.7 39.69 14.43 42.82 13.73 3.13 29.53-10.97 35.29-31.49 5.76-20.52-.7-39.69-14.43-42.82z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M457.49 533.34c1.25.68 2.6 1.19 4.03 1.51 12.89 2.94 27.71-10.3 33.12-29.56 4.61-16.42.88-31.91-8.29-37.95",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M494.51 444.95c-21.49-4.9-46.23 17.18-55.25 49.31-9.02 32.13 1.09 62.14 22.59 67.04 21.49 4.9 46.23-17.18 55.25-49.31 9.02-32.13-1.09-62.15-22.59-67.04zM270.68 444.95c21.49-4.9 46.23 17.18 55.25 49.31 9.02 32.13-1.09 62.14-22.59 67.04-21.49 4.9-46.23-17.18-55.25-49.31-9.02-32.13 1.09-62.15 22.59-67.04z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M438.9 265.02v17.18c0 14.45-25.08 26.16-56.01 26.16s-56.01-11.71-56.01-26.16V265c0 14.45 25.08 26.17 56.01 26.17s55.98-11.7 56.01-26.15z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M382.6 240.07c30.93 0 56.01 11.72 56.01 26.17s-25.08 26.17-56.01 26.17-56.01-11.71-56.01-26.17 25.08-26.17 56.01-26.17zm0 7.98c-21.06 0-38.13 7.98-38.13 17.82s17.07 17.82 38.13 17.82 38.13-7.98 38.13-17.82-17.07-17.82-38.13-17.82z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M397.36 291.49l8.07-1.35v17.19l-8.07 1.35v-17.19zm13.45-2.64c5.92-1.44 11.54-3.7 16.77-7.02v18.01c-5.98 3.46-11.48 5.18-16.77 6.2v-17.19z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M373.63 248.71l-8.34.36 6.61 26.31h7.6l-5.87-26.67zm-12.96 3.45l6.7 27.02-5.49 1.85-7.87-3.37-5.26-20.26 11.92-5.24z",
    fill: "#eb6675",
    fillRule: "evenodd"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M405.65 252.19c6.08 1.82 9.34 3.16 13.85 9.17l1.21 8.87c-7.09 6.72-16.44 10.63-24.44 11.67l9.38-29.7z",
    fill: "#7e0530",
    fillRule: "evenodd"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M351.73 275.93c3.36-6.69 15.9-11.66 30.87-11.66s27.78 5.08 30.97 11.88",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M382.6 264.27v10.56m26.7-3.97l-6.42 8.8m-46.99-8.8l6.42 8.8m39.97-12.11l-5.43 10.28m-33.95-10.28l5.43 10.28m24.82-12.63l-2.46 10.56m-18.67-10.56l2.46 10.56",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M355.07 306.23c-7.8-1.86-15.07-5.13-21.64-10.25v-17.2c6.57 5.24 13.89 8.29 21.59 10.24.02 5.74.04 11.47.05 17.21zm7.51 1.47c2.5.41 5 .83 7.5 1.24v-17.19c-2.5-.41-5-.83-7.5-1.24v17.19z",
    fill: "#45454d",
    fillRule: "evenodd"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M382.54 285.98c9.97 0 18.1-2.4 18.1-5.34s-8.13-5.34-18.1-5.34-18.09 2.4-18.09 5.34 8.13 5.34 18.09 5.34z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M364.3 281.27c2.28-3.72 9.61-6.44 18.3-6.44s16.62 2.95 18.55 6.9",
    fill: "none",
    stroke: "#1a1a18",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M344.48 265.38c.33 1.53.67 3.06 1 4.58 18.02-18.6 65.46-15.03 74.1.26.38-1.45.77-2.9 1.15-4.36-2.93-23.47-71.44-21.84-76.25-.49z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M350.87 265.57c3.47-2.26 7.48-4.03 11.8-5.33l-1.99-8.04c-.14.05-.28.1-.42.14l-7.34 3.23c-1.46.84-2.78 1.77-3.92 2.76l1.88 7.23zm16.89-6.63c2.56-.54 5.19-.94 7.85-1.2l-1.83-8.31c-2.77.33-5.48.79-8.06 1.39l2.04 8.13z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M403.21 259.92c7.71 2.2 13.79 5.72 16.37 10.3l.74-2.81-.73-5.33c-1.74-3.57-5.2-6.39-9.75-8.5-1.26-.49-2.64-.93-4.2-1.4l-2.44 7.73z",
    fill: "#45454d",
    fillRule: "evenodd"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M382.6 283.68c21 0 38.13-8 38.13-17.82s-17.13-17.82-38.13-17.82-38.13 8-38.13 17.82 17.13 17.82 38.13 17.82z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M346.81 270.58c3.34-7.81 18.09-13.69 35.79-13.69s33.23 6.2 36.03 14.32",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.73 320.57c.25-5.01.5-10.01.76-15.02-13.31-4-23.54-10.22-25.89-22.12.04-6.26.07-12.51.11-18.77-10.84 4.84-18.04 12.53-19.34 20.74-1.52 9.61 5.7 17.23 12.57 22.66 9.62 7.6 20.18 10.27 31.8 12.52z",
    fill: "#d30334"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.6 265.02h.59c11.76 6.22 18.9 14.4 18.9 23.35 0 19.48-33.8 35.27-75.5 35.27-37.66 0-68.87-12.88-74.57-29.72l43.67 13.32.8-1.73c8.69 2.59 19.02 4.09 30.09 4.09 30.93 0 56.01-11.71 56.01-26.16v-18.42z",
    fill: "#eb6675"
  }))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M438.6 266.26v17.18c0 14.45-25.07 26.16-56.01 26.16s-56.01-11.71-56.01-26.16h0v-17.2c0 14.45 25.08 26.17 56.01 26.17s55.98-11.7 56.01-26.15z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M439.2 265.02c11.76 6.22 18.9 14.39 18.9 23.35 0 19.48-33.8 35.27-75.5 35.27s-75.5-15.79-75.5-35.27c0-9.13 7.42-17.45 19.6-23.71",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M382.6 292.41c30.85 0 56.01-11.75 56.01-26.17s-25.16-26.17-56.01-26.17-56.01 11.75-56.01 26.17 25.16 26.17 56.01 26.17zM277.95 318.1l-33.58 49.89c-11.73 15.94-19.18 33.87-8.4 52.93 5.51 9.75 15.37 18.69 28.55 26.31m48.2 18.44c20.91 5.08 44.69 7.96 69.89 7.96s48.64-2.83 69.45-7.85m48.51-18.47c13.24-7.64 23.14-16.6 28.67-26.39 10.78-19.06 3.33-36.99-8.4-52.93l-33.58-49.89",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M237.4 469.35c2.13 3.3 4.76 6.49 7.85 9.57m83.85 36.24c4.74.83 9.59 1.56 14.54 2.17m16.88 1.62a325.743 325.743 0 0044.47-.02m16.87-1.63c4.81-.6 9.53-1.31 14.13-2.12m83.76-36.07c2.98-2.94 5.54-6 7.64-9.15",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M230.94 493.05c0 14.44 9.24 27.87 25.11 39.06m57.5 24.04c20.71 4.96 44.18 7.75 69.05 7.75s48.55-2.82 69.33-7.82m57.17-23.93c15.9-11.21 25.16-24.65 25.16-39.1M230.94 493.05l-.2-92.38M534.25 493.05l.21-92.38",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M443.15 467.49c-5.29-11.4-30.3-20.04-60.37-20.04s-55.71 8.86-60.56 20.47",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M435.56 447.06c-8.48-8.32-28.92-14.18-52.78-14.18s-45.57 6.24-53.54 14.97M435.42 571.17c-3.81-3.58-9.85-6.69-17.42-9.05m-70.87.26c-7.46 2.42-13.36 5.57-17 9.18M267.46 418.65c-1.25-16.21-13.46-29.67-29.39-37.57M497.74 418.65c1.25-16.21 13.46-29.66 29.39-37.57M494.55 404.22c1.16-15.12 11.86-27.84 26.22-35.9M270.65 404.22c-1.16-15.12-11.86-27.84-26.22-35.9M501.78 446.59c-29.47-25.58-44.52-19.37-50.89 20.23M263.41 446.59c29.47-25.58 44.52-19.37 50.89 20.23",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M322.23 467.49c15.57-49.75 37.92-74.48 60.37-74.22 22.44-.26 44.79 24.47 60.37 74.22M325.53 559.23c15.34 43.15 36.17 64.59 57.07 64.34 20.95.25 41.82-21.29 57.17-64.62M248.89 361.26c31.76-33.75 33.47 9.4 11.48 83.47M516.3 361.26c-31.76-33.75-33.47 9.4-11.48 83.47M492.74 584.95c-3.97-5.9 1.58-23.63 19.47-55.09M272.46 584.95c3.97-5.9-1.58-23.63-19.47-55.09M343.54 499.69c5.47.62 11.09 1.08 16.87 1.4v35.06c-5.68-.16-11.32-.84-16.87-1.68v-34.78zM421.66 499.69c-5.47.62-11.09 1.08-16.87 1.4v35.06c5.68-.16 11.32-.84 16.87-1.68v-34.78zM534.32 444.03c-1.79 3.79-3.92 7.46-6.69 10.82v33.65c2.38-2.8 4.74-6.48 6.73-10.32M230.87 444.03c1.79 3.79 3.92 7.46 6.69 10.82v33.65c-2.38-2.8-4.74-6.48-6.74-10.32",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4,
    d: "M475.55 393.12l-13.38-16.97M289.65 393.12l13.37-16.97"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M459.89 598.78l-6.25 26.26M305.25 598.77l6.31 26.27"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M382.6 339.98c-20.47-.29-41.95-3.52-58.8-8.53-23.59-7.02-38.84-18.02-45.86-35.37v26.13c1.79 14.37 10.08 22.76 21.05 28.67l4.03 25.26c2.39-13.74 11.63-18.03 18.78-16.75 6.76 1.21 12.86 4.92 21.41 15.7l5.05-7.42a211.31 211.31 0 0034.34 2.85v-.09c11.4 0 22.84-.95 34.34-2.85l5.05 7.42c8.55-10.78 14.64-14.49 21.41-15.7 7.15-1.28 16.39 3.01 18.78 16.75 1.34-8.42 2.68-16.84 4.03-25.26 10.97-5.92 19.26-14.3 21.05-28.67v-26.13c-7.01 17.35-22.26 28.35-45.86 35.37-16.85 5.02-38.33 8.24-58.79 8.53v.09z",
    fill: "#6d6f7a",
    fillRule: "evenodd"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M406.21 337.35l17.45-2.54v39.8l-1.82 2.18-4.63-7.57-10.99 1.13v-33zm29.07-5.61c12.81-3.12 24.96-8.94 36.26-16.11v32.94l-4.54 2.97-4.68 25.59c-3.71-14.79-12.8-21.54-27.03-14.22v-31.18zM406.21 636.55l17.45-2.54v30.16c-3.47.66-10.57 1.8-17.45 2.66v-30.28zm29.07-5.61c12.81-3.12 24.96-8.94 36.26-16.11v30.12c-12.07 8.95-20.2 12.42-36.26 17.16v-31.18z",
    fill: "#babac1",
    fillRule: "evenodd"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M327.54 361.8c-11.44-4.34-20.63-1.8-25.08 15.89-.33 1.32-3.34-25.49-4.76-26.48-3.57-2.51-8.66-6.63-11.53-8.86v-33.67c9.84 9.96 24.62 18.64 41.26 22.85l.11 30.27zm16.25 13.59c2.58-3.43 3.96-4.84 5.85-6.67 1.94.22 3.8.42 6.72.9v-32.7c-5.4-.89-7.16-1-12.57-1.9v40.36zM327.54 661c-15.86-4.2-29.81-11.53-41.37-22.79v-30.33c9.84 9.95 24.62 18.64 41.26 22.85l.11 30.27zm16.25 4.12c2.45.71 9.84 1.56 12.57 2.02v-31.01c-5.4-.89-7.16-1-12.57-1.9v30.89z",
    fill: "#45454d",
    fillRule: "evenodd"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M487.25 321.47c0 11.04-7.84 21.23-21.05 29.42l9.35 42.23c-10.51 5.37-21.66 9.23-33.45 11.54l-25.16-36.98c-10.76 1.74-22.31 2.69-34.34 2.69s-23.58-.95-34.34-2.69l-25.16 36.98c-11.79-2.31-22.94-6.17-33.45-11.54l9.35-42.23c-13.22-8.18-21.05-18.37-21.05-29.42",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M421.47 375.86c14.06-21.35 36.4-23.11 40.7.29M343.73 375.86c-14.06-21.35-36.4-23.11-40.7.29",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M299 350.89l4.03 25.26c10.13 5.76 19.9 8.63 31.69 11.67M466.2 350.89l-4.03 25.26c-10.13 5.76-19.9 8.63-31.69 11.67M412.53 244.14c43.21 6.02 74.72 24.72 74.72 46.87 0 27-46.85 48.89-104.65 48.89s-104.65-21.89-104.65-48.89c0-21.96 30.97-40.53 73.62-46.71.38-.05.76-.11 1.14-.16M487.25 619.18c0 27-46.85 48.89-104.65 48.89s-104.65-21.89-104.65-48.89",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M487.25 609.17c0 27-46.85 48.89-104.65 48.89s-104.65-21.89-104.65-48.89M487.25 301.12c0 27-46.85 48.89-104.65 48.89s-104.65-21.89-104.65-48.89",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M487.25 291v31.6m0 273.93v22.65M277.95 291v31.22m0 273.27v23.7M531.77 505.88l-44.52 89.71c-4.25 8.57-11.52 16.63-22.13 23.32-22.91 14.44-55.98 19.54-82.52 19.54s-59.61-5.1-82.53-19.54c-10.61-6.69-17.87-14.75-22.13-23.32l-44.52-89.71",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 4
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5,
    d: "M314.67 327.31l20.14-11.63M451.54 327.89l-21.15-12.21M435.46 257.57l9.88-5.7M329.74 257.57l-10.99-6.35M278.66 286.97h28.84m151.12 0h28.13M382.6 323.64v16.25"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M467.51 573.68c-8.93 1.25-14.47 6.82-15.76 17.82 8.92-.86 14.15-6.83 15.76-17.82zM297.69 573.68c8.93 1.25 14.47 6.82 15.76 17.82-8.92-.86-14.15-6.83-15.76-17.82z",
    fill: "#fff",
    fillRule: "evenodd"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M294.19 575.79c-3.2 3.91-1.86 11.79 3 17.59s11.39 7.33 14.59 3.42 1.86-11.79-3-17.59c-4.86-5.8-11.39-7.33-14.59-3.42z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M297.69 573.68c-.11 3.88 1.56 8.55 4.73 12.33 3.43 4.09 7.69 6.06 11.02 5.49M467.51 573.68c.11 3.88-1.56 8.55-4.73 12.33-3.43 4.09-7.69 6.06-11.02 5.49",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M471 575.79c3.2 3.91 1.86 11.79-3 17.59-4.86 5.8-11.39 7.33-14.59 3.42-3.2-3.91-1.86-11.79 3-17.59 4.86-5.8 11.39-7.33 14.59-3.42z",
    fill: "none",
    stroke: "#000003",
    strokeMiterlimit: 22.93,
    strokeWidth: 2.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTest3);
export default __webpack_public_path__ + "static/media/test3.5942704af14559fcb7d55d0b858f647a.svg";
export { ForwardRef as ReactComponent };